import { some } from 'lodash-es';

const IMAGE = {
  LOADING: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOiBhdXRvOyBiYWNrZ3JvdW5kOiByZ2JhKDI1NSwgMjU1LCAyNTUsIDApOyBkaXNwbGF5OiBibG9jazsgc2hhcGUtcmVuZGVyaW5nOiBhdXRvOyIgd2lkdGg9IjUwcHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIj4KPHBhdGggZD0iTTMzIDUwQTE3IDE3IDAgMCAwIDY3IDUwQTE3IDE4LjYgMCAwIDEgMzMgNTAiIGZpbGw9IiNkMGQwZDAiIHN0cm9rZT0ibm9uZSI+CiAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGR1cj0iMXMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBrZXlUaW1lcz0iMDsxIiB2YWx1ZXM9IjAgNTAgNTAuODszNjAgNTAgNTAuOCI+PC9hbmltYXRlVHJhbnNmb3JtPgo8L3BhdGg+CjwhLS0gW2xkaW9dIGdlbmVyYXRlZCBieSBodHRwczovL2xvYWRpbmcuaW8vIC0tPjwvc3ZnPg==',
  ERROR: 'data:image/svg+xml;base64,PHN2ZyB0PSIxNjA0OTkxODI4Nzk4IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjI0OTAiIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIj48cGF0aCBkPSJNMzIwIDQ0Ny45MzZjMzUuMzkyIDAgNjQtMjguNjA4IDY0LTY0cy0yOC42MDgtNjQtNjQtNjQtNjQgMjguNjA4LTY0IDY0UzI4NC42MDggNDQ3LjkzNiAzMjAgNDQ3LjkzNnpNNzUxLjc0NCA3MDYuNzUyYy0xNDYuNDk2LTkxLjAwOC0zMzMuNDQtOTEuMDA4LTQ3OS44NzIgMC0xNC4zMzYgOC44OTYtMTkuMzI4IDI4LjczNi0xMS4yNjQgNDQuNDggOCAxNS43NDQgMjYuMDQ4IDIxLjI0OCA0MC4zODQgMTIuMzUyIDEyOC43MDQtNzkuOTM2IDI5Mi44NjQtNzkuOTM2IDQyMS42MzIgMCA0LjU0NCAyLjg4IDkuNiA0LjIyNCAxNC41MjggNC4yMjQgMTAuMzY4IDAgMjAuNDE2LTYuMDE2IDI1Ljg1Ni0xNi42NEM3NzEuMDcyIDczNS40ODggNzY2LjAxNiA3MTUuNjQ4IDc1MS43NDQgNzA2Ljc1MnpNODMyIDEyNy45MzYgMTkyIDEyNy45MzZjLTcwLjY1NiAwLTEyOCA1Ny4zNDQtMTI4IDEyOGwwIDU3NmMwIDcwLjY1NiA1Ny4zNDQgMTI4IDEyOCAxMjhsNjQwIDBjNzAuNjU2IDAgMTI4LTU3LjM0NCAxMjgtMTI4bDAtNTc2Qzk2MCAxODUuMjggOTAyLjY1NiAxMjcuOTM2IDgzMiAxMjcuOTM2ek04OTYgODMxLjkzNmMwIDM1LjM5Mi0yOC42MDggNjQtNjQgNjRMMTkyIDg5NS45MzZjLTM1LjM5MiAwLTY0LTI4LjYwOC02NC02NGwwLTU3NmMwLTM1LjM5MiAyOC42MDgtNjQgNjQtNjRsNjQwIDBjMzUuMzkyIDAgNjQgMjguNjA4IDY0IDY0TDg5NiA4MzEuOTM2ek03MDQgMzE5LjkzNmMtMzUuMzkyIDAtNjQgMjguNjA4LTY0IDY0czI4LjYwOCA2NCA2NCA2NCA2NC0yOC42MDggNjQtNjRTNzM5LjM5MiAzMTkuOTM2IDcwNCAzMTkuOTM2eiIgcC1pZD0iMjQ5MSIgZmlsbD0iI2U2ZTZlNiI+PC9wYXRoPjwvc3ZnPg==',
};
// 无忧链接的三个关键词
const WUYOU_URL_KEYWORDS = Object.freeze(['__mds_bigR', '__mds_BigR', 'aW9zd2hpdGVsaXN0']);
const imageIsExist = function (url) {
  return new Promise((resolve) => {
    let img = new Image();
    img.onload = function () {
      if (this.complete === true) {
        resolve(true);
        img = null;
      }
    };
    img.onerror = function () {
      resolve(false);
      img = null;
    };
    img.src = url;
  });
};

export default {
  props: {
    styles: {
      type: Object,
      default: () => ({
        base: {},
      }), // 样式默认值
    },
    configurationData: {
      type: Object,
      default: () => ({}),
    },
    intervalDataFetchList: {
      type: Object,
      default: () => ({}),
    },
    events: {
      type: Array,
      default: () => [],
    },
    production: {
      type: Boolean,
      default: true,
    },
    uid: {
      // 组件实例uuid
      type: String,
      default: '',
    },
    uname: {
      // 组件实例名称
      type: String,
      default: '',
    },
    cid: {
      // componentId,注册在平台的组件id
      type: Number,
      default: 0,
    },
    tags: {
      // 组件tag,用于数据分析
      type: String,
      default: '',
    },
  },
  directives: {
    async src(el, binding) {
      const { dataset } = el;
      const { nowsrc: nowSrc } = dataset;
      const { value: realImage } = binding;
      if (nowSrc === realImage) {
        return;
      }
      el.setAttribute('src', IMAGE.LOADING);
      dataset.nowsrc = realImage;
      const exist = realImage && await imageIsExist(realImage);
      if (exist) {
        el.setAttribute('src', realImage);
        dataset.nowsrc = realImage;
      } else {
        el.setAttribute('src', IMAGE.ERROR);
      }
    },
  },
  data() {
    return {
      baseCssPrefix: 'csu-',
      cssPrefix: '',
      classKeys: [],
      clickTimes: 0,
    };
  },
  computed: {
    classes() {
      return this.classKeys.reduce((acc, curr) => Object.assign(acc, {
        [curr]: this.getCss(curr),
      }), {});
    },
    clickable() {
      return this.events && some(this.events, ['trigger', 'click']);
    },
    eventsMap() {
      return this.events.reduce((acc, item) => {
        acc.set(item.trigger, item);
        return acc;
      }, new Map());
    },
  },
  watch: {
    'styles.base.displayVal'(nVal) {
      if (nVal !== 'none') {
        // 上报曝光事件
        this.reportExpose?.({
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
        });
        if (this.configurationData?.reportExpose && this.$report.expose) {
          this.$report.expose(this.configurationData.reportExpose);
        }
      }

      this.handleEvent(nVal === 'none' ? 'hide' : 'show');
    },
  },
  created() {
    if (this.styles.base.displayVal !== 'none') {
      // 组件初始化时如果不是隐藏状态,则立马曝光一次

      // 由于组件使用ref引入c-button，因为mixin机制导致上报两次曝光，所以过滤掉
      if (this.$options?.name === 'CButton' && this.$options?.parent?.$options?.propsData?.uid) {
        return;
      }
      this.reportExpose?.({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
      if (this.configurationData?.reportExpose && this.$report.expose) {
        this.$report.expose(this.configurationData.reportExpose);
      }
    }
  },
  methods: {
    getCss(classes) {
      if (typeof classes === 'string') {
        return `${this.baseCssPrefix}${this.cssPrefix}${classes}`;
      }

      return classes.reduce((acc, curr) => `${acc} ${this.baseCssPrefix}${this.cssPrefix}${curr}`, '');
    },
    handleClickEvent() {
      // 上报点击事件
      this.reportClick({
        ceibaComponentId: `${this.cid}`,
        ceibaComponentUid: this.uid,
        ceibaComponentUname: this.uname,
      });
      // 上报业务点击事件
      if (this.configurationData?.reportClick && this.$report.click) {
        this.$report.click(this.configurationData.reportClick);
      }
      this.clickTimes += 1;
      this.handleEvent('click');
      this.clickTimes = 0;
      // 临时关闭双击事件的判断与采集
      // this.clickTimes += 1;
      // if (this.clickTimes >= 2) {
      //   this.handleEvent('dblclick');
      //   this.clickTimes = 0;
      // }
      // setTimeout(() => {
      //   if (this.clickTimes === 1) {
      //     this.handleEvent('click');
      //     this.clickTimes = 0;
      //   }
      // }, 200);
    },
    handleEvent(trigger) {
      const event = this.eventsMap.get(trigger);
      if (event) {
        this.$emit('defined-event-emitted', [event]);
      }
    },
    /**
     * 根据规则检查不同的内容
     * @param link
     * @param type
     * @returns {boolean}
     */
    checkUrlRuleType(link, type = 'ruleByKeyWord') {
      switch (type) {
        case 'ruleByKeyWord':
          return  [...WUYOU_URL_KEYWORDS, 'ios_whitelist'].some(i => link.includes(i));
        default :
          return false;
      }
    },
  },
};
